export default __webpack_public_path__ + "static/media/mt4_ios.ab37d2e5.png";